import React, { Component } from 'react';
import './SearchBox.scss';
import SearchBar from 'material-ui-search-bar';
import TextField from '@material-ui/core/TextField';
import Autocomplete, { createFilterOptions } from '@material-ui/lab/Autocomplete';
// import SearchIcon from '@material-ui/icons/Search';
// import InputAdornment from '@material-ui/core/InputAdornment';
// import '../Textfield/TextFieild.scss';

type initialProps = {
    value?: any;
    onChange?: any;
    label?: string;
    placeholder?: string;
    onRequest?: any;
    style?: any;
    onCancel?: any;
    dropdownList?: any;
    optionLabel?: any;
    onTextFieldChange?: any;
    filterOptions?: any;
};

type initialState = {};
const filter = createFilterOptions();
export class SearchBoxComponent extends Component<initialProps, initialState> {
    render() {
        return (
            <SearchBar
                className="SearchBox"
                onChange={this.props.onChange}
                onRequestSearch={this.props.onRequest}
                value={this.props.value}
                onCancelSearch={this.props.onCancel}
                style={this.props.style}
                placeholder={this.props.placeholder ? this.props.placeholder : 'Search'}
            />
        );
    }
}
export class SearchBoxWithDropdown extends Component<initialProps, initialState> {
    render() {
        return (
            <Autocomplete
                className="SearchBoxDropdown"
                value={this.props.value}
                onChange={(e: any, val: any) => this.props.onChange(e, val)}
                filterOptions={(options: any, params: any) => {
                    const filtered = filter(options, params);
                    if (params.displayName !== '') {
                        filtered.push({
                            displayName: `Other`,
                        });
                    }
                    return filtered;
                }}
                selectOnFocus
                clearOnBlur
                handleHomeEndKeys
                id="free-solo-with-text-demo"
                options={this.props.dropdownList}
                getOptionLabel={(option: any) => {
                    return option.displayName;
                }}
                renderOption={(option: any) => option.displayName}
                style={{ width: 300 }}
                freeSolo
                renderInput={(params) => (
                    <TextField {...params} variant="outlined" />
                )}
            />
        );
    }
}
